import React from "react";
import styled from 'styled-components';
import colors from "../../../../../utils/colors";
import Block from '../../Block';
import Text from '../../Text';

function TextInput(
    {
        label,
        error,
        onChangeValue,
        value = "",
        ...props
    }
) {
    return (
        <Block width="100%">
            {!!label && <Text size={12} height={16} color={colors.grey01} bold mb={12}>{label}</Text>}
            <Block>
                <Input
                    label={label}
                    type="text"
                    error={error}
                    value={value}
                    onChange={(e) => !!onChangeValue && onChangeValue(e.target.value)}
                    {...props}
                />
            </Block>
            {(() => {
                let color = null;
                let text = null;
                if (!!error) { text = typeof error === "string" ? error : null; color = colors.red01; }

                if (!!text) {
                    return (
                        <Block mt={8}>
                            <Text
                                size={11}
                                height={16}
                                color={color}
                            >
                                {error}
                            </Text>
                        </Block>
                    );
                }
            })()}
        </Block>
    );
}

export default React.memo(TextInput);

const Input = styled.input`
    background-color: ${colors.grey06};
    height: 52px;
    color: ${colors.grey01};
    font-size: 14px;
    line-height: 24px;
    font-family: "Aeonik-Regular";
    border: 0;
    padding: 8px 16px;
    border-radius: 10px;

    ::placeholder {
        color: ${colors.grey03};
    }
`;